import produce from 'immer';
import { AUTH, FAILURE, LOGOUT, REGISTER, REQUEST, SET, SUCCESS, USER_INFO } from '../constants/constants';
import { toast } from 'react-toastify';

const safeParse = (key) => {
    const value = localStorage.getItem(key);
    if (value == null) return null;

    try {
        return JSON.parse(value);
    } catch {
        return value;
    }
};

const initialState = {
    isLoading: false,
    isLoaded: false,
    email: safeParse('ct_account_email'),
    currency: safeParse('ct_account_currency'),
    user_id: safeParse('ct_account_user_id'),
};

export default produce((draft = initialState, action) => {
    const { type, data, error, errorProcessed } = action;

    switch (type) {
        case AUTH + REQUEST:
        case REGISTER + REQUEST:
            draft.isLoading = true;
            break;
        case AUTH + SUCCESS:
            saveUserInfo(draft, data);
            break
        case REGISTER + SUCCESS:
            draft.isLoading = false;
            draft.isLoaded = true;
            break;
        case AUTH + FAILURE:
        case REGISTER + FAILURE:
            draft.isLoading = false;
            draft.isLoaded = false;
            localStorage.clear();
            if (error && !errorProcessed) {
                toast.error(error);
            }
            break;
        case USER_INFO + SET:
            saveUserInfo(draft, data);
            break;
        case LOGOUT:
            draft.email = null;
            draft.user_id = null;
            draft.isLoading = false;
            draft.isLoaded = false;
            localStorage.clear();
            break;
        default:
            return draft;
    }
});

const saveUserInfo = (draft, data) => {
    draft.email = data?.email ?? null;
    localStorage.setItem('ct_account_email', data?.email ?? null);
    draft.currency = data.currency;
    localStorage.setItem('ct_account_currency', data.currency);
    draft.user_id = data?.user_id;
    localStorage.setItem('ct_account_user_id', data?.user_id);
};
